import { productFruits } from 'product-fruits'

function isMobileDevice() {
  // Check if screen width is less than or equal to 768px (typical mobile/tablet breakpoint)
  return window.innerWidth <= 768
}

export function initProductFruits({ email, firstname, lastname, role, profileId, appUserId }) {
  const productFruitsEnabled = import.meta.env.VITE_PRODUCT_FRUITS_ENABLED === 'true'

  if (!productFruitsEnabled) {
    return
  }

  // Don't initialize Product Fruits on mobile devices
  if (isMobileDevice()) {
    console.log('[Product Fruits] Disabled on mobile devices')
    return
  }

  productFruits.init(
    import.meta.env.VITE_PRODUCT_FRUITS_WORKSPACE_CODE,
    import.meta.env.VITE_PRODUCT_FRUITS_LANGUAGE_CODE,
    {
      email,
      firstname,
      lastname,
      role,
      props: {
        profileId,
        appUserId,
      },
      username: email,
    },
    {
      disableLocationChangeDetection: true,
    },
  )
}

/**
 * type ProductFruitsUserObject = {
 *     username: string;
 *     email?: string;
 *     role?: string;
 *     signUpAt?: string;
 *     firstname?: string;
 *     lastname?: string;
 *     props?: UserCustomProps;
 *     hmac?: {
 *         hash: string;
 *         expiration?: string | null | undefined;
 *     };
 *     group?: {
 *         groupId?: string;
 *         props?: UserGroupCustomProps;
 *     };
 * };
 * @param user
 */
